import { jsx as i } from "react/jsx-runtime";
import { forwardRef as v, useState as _ } from "react";
import { useTranslation as F } from "react-i18next";
import * as c from "react-datepicker";
import g from "react-input-mask";
import { format as D } from "date-fns";
import N from "classnames";
import O from "../FieldContainer/index.js";
import U from "../../helpers/nanoid.js";
const j = "forma-ui__datepicker__input", A = "forma-ui__datepicker__withIcon", L = "forma-ui__datepicker__readonly", P = "forma-ui__datepicker__secondary", s = {
  input: j,
  withIcon: A,
  readonly: L,
  secondary: P
}, Y = 300, Z = c.default.default || c.default || c, W = v(({
  id: l = U(8),
  name: d,
  onChange: u,
  onFocus: p,
  onBlur: f,
  readOnly: a,
  hidden: k,
  viewStyle: I = "primary",
  className: M,
  placeholder: w,
  value: r,
  required: C,
  meta: o,
  ...b
}, T) => {
  const [h, t] = _(!1), [x, e] = _(!1), { t: y } = F(), S = (n) => {
    if (!n)
      return;
    const R = D(n, "yyyy-MM-dd");
    u && u({ target: { name: d, value: R } });
  }, B = (n) => {
    p && p(n), e(!0), t(!0);
  }, E = (n) => {
    f && f(n), e(!1), setTimeout(() => t(!1), Y);
  };
  return /* @__PURE__ */ i(
    O,
    {
      id: l,
      hidden: k,
      required: C,
      isShowButtons: h,
      isShowTooltip: x,
      isShowIcon: h || (o == null ? void 0 : o.showIconAlways),
      ...o,
      children: /* @__PURE__ */ i(
        Z,
        {
          id: l,
          name: d,
          onChange: S,
          onFocus: B,
          onBlur: E,
          className: N(
            s.input,
            s[I],
            M,
            ((o == null ? void 0 : o.icon) || (o == null ? void 0 : o.buttons) || (o == null ? void 0 : o.showClearButton)) && s.withIcon,
            (o == null ? void 0 : o.error) && "error",
            (o == null ? void 0 : o.success) && "success",
            a && s.readonly
          ),
          placeholderText: w ?? y("uikit:select_date"),
          selected: r ? new Date(r) : null,
          autoComplete: "off",
          locale: "ru",
          showMonthDropdown: !0,
          showYearDropdown: !0,
          dropdownMode: "select",
          dateFormat: "dd.MM.yyyy",
          minDate: o != null && o.minDate ? new Date(o == null ? void 0 : o.minDate) : /* @__PURE__ */ new Date("1900-01-01T00:00:00.000Z"),
          maxDate: o != null && o.maxDate ? new Date(o == null ? void 0 : o.maxDate) : null,
          customInput: (
            // TODO: format depends of locale
            /* @__PURE__ */ i(
              g,
              {
                mask: "a9.b9.c999",
                maskChar: null,
                placeholder: w ?? y("uikit:select_date"),
                value: r ? D(new Date(r), "dd.MM.yyyy") : "",
                inputMode: "decimal",
                formatChars: {
                  9: "[0-9]",
                  a: "[0-3]",
                  b: "[0-1]",
                  c: "[1-2]"
                },
                readOnly: a,
                ...b,
                inputRef: T
              }
            )
          ),
          onCalendarClose: () => {
            document.dispatchEvent(new Event("datepickerClose", { bubbles: !0 })), e(!1), t(!1);
          },
          onCalendarOpen: () => {
            document.dispatchEvent(new Event("datepickerOpen", { bubbles: !0 }));
          },
          portalId: o == null ? void 0 : o.portalId
        }
      )
    }
  );
});
export {
  W as default
};
